export const SHOW_NOTIFICATION_MODAL = "SHOW_NOTIFICATION_MODAL"
export const HIDE_NOTIFICATION_MODAL = "HIDE_NOTIFICATION_MODAL"
export const LOAD_SHOP_LIST_VIEW = "LOAD_SHOP_LIST_VIEW"
